import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { LayoutLibrary } from '../..'
import { SizeTracker } from '../../../common/SizeTracker'
import { Loading } from '../../../common/loading'
import { Table } from '../../../common/table'
import ErrorCustom, { errorTypes } from '../../../errors/ErrorCustom'
import { getListIdSelectByObj } from '../../helper'
import { selectFragment } from '../portfoliosOverview/store/slice/sliceComponent'
import { getAlertProfile } from '../portfoliosOverview/store/thunk'
import { PaginationTableDetail } from './components/PaginationTableDetails'
import { MAP_SORT_TABLE_DETAIL } from './constant'
import { HeaderDetailsPortfolio } from './headerDetails'
import { Header } from './headerDetails/Header'
import classes from './index.module.scss'
import { getSchemaTableDetailsPortfolio } from './schemaTableDetailPortfolio'
import {
  changeFilter,
  changeTypeAlertDetail,
  resetStore,
  selectDataCheckBox,
  selectDataFilter,
  selectDataTablePortfolioDetail,
  selectIdsTablePortfolioDetail,
  selectIsRedirect404,
  selectLoadingHeaderPortfolioDetail,
  selectLoadingTablePortfolioDetail,
  selectTextSearch,
} from './store/slice'
import {
  getAllIdCompanyInPortfolio,
  getHeaderSavedPortfolioDetail,
  getSearchCompanyInPortfolioDetails,
} from './store/thunk'

const DetailsPortfolios = () => {
  const dispatch = useDispatch()

  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const { page, pageSize, sort, sortDirection } = useSelector(selectDataFilter)
  const filter = useSelector(selectDataFilter)
  const listIdsTable = useSelector(selectIdsTablePortfolioDetail)
  const textSearch = useSelector(selectTextSearch)
  const isFragment = useSelector(selectFragment)
  const isLoadingTable = useSelector(selectLoadingTablePortfolioDetail)
  const isLoadingHeader = useSelector(selectLoadingHeaderPortfolioDetail)
  const locale = useSelector((state) => state.i18n.locale)
  const checkboxObj = useSelector(selectDataCheckBox('listIdsSelected'))
  const listIdSelect = getListIdSelectByObj(checkboxObj)
  const isRedirect404 = useSelector(selectIsRedirect404)

  const handleChangeSort = (sort) => {
    dispatch(
      changeFilter({
        sort: sort?.sortBy,
        sortDirection: sort?.sortDirection,
        page: 1,
      }),
    )
  }

  useEffect(() => {
    dispatch(
      getSearchCompanyInPortfolioDetails({
        term: textSearch,
        portfolioId: id,
        Page: page,
        PageSize: pageSize,
        Sort: MAP_SORT_TABLE_DETAIL[sort],
        SortDirection: sortDirection,
      }),
    )
  }, [JSON.stringify(filter), isFragment, textSearch, locale])

  useEffect(() => {
    dispatch(getAlertProfile())
    dispatch(getHeaderSavedPortfolioDetail({ portfolioId: id }))
  }, [locale])

  useEffect(() => {
    return () => {
      dispatch(changeTypeAlertDetail({}))
      dispatch(resetStore())
    }
  }, [])

  useEffect(() => {
    dispatch(
      getAllIdCompanyInPortfolio({
        term: textSearch,
        portfolioId: id,
      }),
    )
  }, [textSearch])

  if (isLoadingHeader) {
    return <Loading />
  }

  if (isRedirect404) {
    return <ErrorCustom errorType={errorTypes.NOT_FOUND} />
  }

  return (
    <LayoutLibrary
      renderTopComponent={() => {
        return (
          <div style={{ padding: '0 6px' }}>
            <Header />
          </div>
        )
      }}
      renderBottomComponent={() => {
        return (
          <>
            <div
              className={classes.detailPortfolioContent}
              style={{ padding: '0 6px' }}
            >
              {isLoadingTable && <Loading />}
              <SizeTracker
                renderTopComponent={() => <HeaderDetailsPortfolio />}
              >
                {(size) => {
                  return (
                    <div
                      style={{
                        opacity: isLoadingTable ? 0 : 1,
                        height: `calc(100% - ${size.height}px)`,
                      }}
                    >
                      <Table
                        keyReCalculateSize={listIdSelect?.length}
                        getDataFromRedux={selectDataTablePortfolioDetail}
                        ids={listIdsTable}
                        isLoading={isLoadingTable}
                        isNoDataWithHead
                        schema={getSchemaTableDetailsPortfolio()}
                        sort={{
                          sortBy: sort,
                          sortDirection: sortDirection,
                        }}
                        changeSort={handleChangeSort}
                        renderPagination={() => <PaginationTableDetail />}
                        isCenterNoData={false}
                      />
                    </div>
                  )
                }}
              </SizeTracker>
            </div>
          </>
        )
      }}
    />
  )
}

export default DetailsPortfolios
